import BarchartWidgetForm from "pages/Report/BarchartWidgetForm";
import PredictionWidgetForm from "pages/Report/PredictionWidgetForm";
import TextWidgetForm from "pages/Report/TextWidgetForm";
import GaugeWidgetForm from "components/GaugeWidgetForm";
import NormalizedWidgetForm from "components/NormalizedWidgetForm";
import TagWidgetForm from "components/TagWidgetForm";
import TimeseriesWidgetForm from "components/TimeseriesWidgetForm";

import BarChart from "../assets/Report/ic_barchart.svg";
import Gauge from "../assets/Report/ic_gauge.svg";
import NormalizeSeries from "../assets/Report/ic_normalized_series.svg";
import Predict from "../assets/Report/ic_predict.svg";
import Text from "../assets/Report/ic_text.svg";
import Trending from "../assets/Report/ic_trending.svg";
import BarChartIcon from "../assets/Widget/bar_chart.svg";
import GaugeIcon from "../assets/Widget/gauge.svg";
import NormalizedSeriesIcon from "../assets/Widget/normalized_series.svg";
import PredictTagIcon from "../assets/Widget/predict_tag.svg";
import TaglistIcon from "../assets/Widget/tag_list_icon.svg";
import FreeTextIcon from "../assets/Widget/text.svg";
import TimeSeriesIcon from "../assets/Widget/trending_up.svg";

import { AddWidgetStrings } from "./constantStrings";
import { SYSTEMS_PAGES } from "./pages.constant";
import { WIDGET_TYPES } from "./widgets.type.const";

export const AddWidgetConfig = {
  [SYSTEMS_PAGES.DASHBOARDS]: {
    title: AddWidgetStrings.title,
    description: AddWidgetStrings.dashboardDescription,
    items: [
      {
        groupId: "dashboard_widgets",
        groupName: "",
        widgets: [
          {
            id: WIDGET_TYPES.TIMESERIES,
            label: AddWidgetStrings.timeSeriesLabel,
            icon: TimeSeriesIcon
          },
          {
            id: WIDGET_TYPES.GAUGE,
            label: AddWidgetStrings.gaugeLabel,
            icon: GaugeIcon
          },
          {
            id: WIDGET_TYPES.TAG,
            label: AddWidgetStrings.tagDataLabel,
            icon: TaglistIcon
          }
        ]
      }
    ]
  },
  [SYSTEMS_PAGES.REPORTS]: {
    title: AddWidgetStrings.title,
    description: AddWidgetStrings.reportDescription,
    items: [
      {
        groupId: "reports_calculate_widgets",
        groupName: AddWidgetStrings.calculateStr,
        style: "var(--color-light-teal)",
        widgets: [
          {
            id: WIDGET_TYPES.NORMALIZATION,
            label: AddWidgetStrings.normalizedSeriesLabel,
            icon: NormalizedSeriesIcon
          },
          {
            id: WIDGET_TYPES.PREDICTION,
            label: AddWidgetStrings.predictTagLabel,
            icon: PredictTagIcon
          }
        ]
      },
      {
        groupId: "reports_analyze_widgets",
        groupName: AddWidgetStrings.analyzeStr,
        style: "var(--color-orange)",
        widgets: [
          {
            id: WIDGET_TYPES.TIMESERIES,
            label: AddWidgetStrings.timeSeriesLabel,
            icon: TimeSeriesIcon
          },
          {
            id: WIDGET_TYPES.BAR_CHART,
            label: AddWidgetStrings.barChartLabel,
            icon: BarChartIcon
          },
          {
            id: WIDGET_TYPES.GAUGE,
            label: AddWidgetStrings.gaugeLabel,
            icon: GaugeIcon
          },
          {
            id: WIDGET_TYPES.TAG,
            label: AddWidgetStrings.tagDataLabel,
            icon: TaglistIcon
          },
          {
            id: WIDGET_TYPES.FREE_TEXT,
            label: AddWidgetStrings.freeTextLabel,
            icon: FreeTextIcon
          }
        ]
      }
    ]
  }
};

export const WidgetComponents = {
  [WIDGET_TYPES.TIMESERIES]: TimeseriesWidgetForm,
  [WIDGET_TYPES.TAG]: TagWidgetForm,
  [WIDGET_TYPES.GAUGE]: GaugeWidgetForm,
  [WIDGET_TYPES.NORMALIZATION]: NormalizedWidgetForm,
  [WIDGET_TYPES.PREDICTION]: PredictionWidgetForm,
  [WIDGET_TYPES.BAR_CHART]: BarchartWidgetForm,
  [WIDGET_TYPES.FREE_TEXT]: TextWidgetForm
};

export const ReportWidgetConfigs = {
  [WIDGET_TYPES.TIMESERIES]: {
    icon: Trending,
    color: "var(--color-orange)"
  },
  [WIDGET_TYPES.BAR_CHART]: {
    icon: BarChart,
    color: "var(--color-orange)"
  },
  [WIDGET_TYPES.NORMALIZATION]: {
    icon: NormalizeSeries,
    color: "var(--color-light-teal)"
  },
  [WIDGET_TYPES.GAUGE]: {
    icon: Gauge,
    color: "var(--color-orange)"
  },
  [WIDGET_TYPES.PREDICTION]: {
    icon: Predict,
    color: "var(--color-light-teal)"
  },
  // TODO needs correct ICON and Color for TAG DATA as Design
  [WIDGET_TYPES.TAG]: {
    icon: Text,
    color: "var(--color-orange)"
  },
  [WIDGET_TYPES.FREE_TEXT]: {
    icon: Text,
    color: "var(--color-orange)"
  }
};
